import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgGoogleSolid = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.097 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m.3-14.097c1.072 0 2.034.369 2.791 1.092l2.094-2.094C16.017 5.723 14.365 5 12.397 5a7.298 7.298 0 0 0-6.523 10.578 7.3 7.3 0 0 0 6.523 4.022c1.971 0 3.624-.654 4.832-1.769 1.38-1.27 2.176-3.142 2.176-5.365q-.001-.777-.132-1.493h-6.876v2.823h3.929A3.36 3.36 0 0 1 14.869 16c-.653.438-1.49.697-2.472.697-1.9 0-3.51-1.284-4.084-3.01a4.4 4.4 0 0 1-.23-1.387c0-.481.084-.949.23-1.387.574-1.725 2.183-3.01 4.084-3.01"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgGoogleSolid;
